(function(w, $) {
	function getParam(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name) ?? '';
	}

	// Site header: the mobile menu button, and closing an open dropdown (<details>) when clicking away
	// from it or opening another.
	$(function() {
		$('.rs-site-header__toggle').on('click', function() {
			const open = $(this).attr('aria-expanded') !== 'true';
			$(this).attr('aria-expanded', String(open));
			$('#rs-site-nav').toggleClass('is-open', open);
		});

		$(document).on('click', function(e) {
			$('details.rs-dropdown[open]').each(function() {
				if(!this.contains(e.target)) {
					this.open = false;
				}
			});
		});
	});

	$(function() {
		$('body.login #rememberme').prop('checked', true);
	
		if($('body.login-action-lostpassword').length) {
			const action = getParam('action');
			const email = getParam('email');

			if(action === 'lostpassword' && email) {
				$('#user_login')
					.val(email)
					.closest('form')
					.submit()
					.closest('#login')
					.fadeOut(1000);
			}
		}
	});

	// Disable password stenght indicator on login
	$(function() {
		$('body.login.rs-action-reset #pass-strength-result').remove();
		
		if($('body').hasClass('login-action-rp') && $('body').hasClass('rs-action-reset')) {

			// No idea what is changing this on load, but lets wait a second and then change it to what we want.
			setTimeout(() => {
				$('#wp-submit').attr('value', 'Save password and login');
			}, 100);

		}
	})

	$(function() {
		$(document).on('click', '#download_report', function(e) {
			e.preventDefault();
			const table = document.querySelector('.course-results table');
			if (!table) return;
			let csv = [];
			const rows = table.querySelectorAll('tr');
			rows.forEach(row => {
				const cols = row.querySelectorAll('th, td');
				let rowData = [];
				cols.forEach(col => {
					let text = col.innerText.replace(/"/g, '""');
					rowData.push('"' + text + '"');
				});
				csv.push(rowData.join(','));
			});
			const csvContent = csv.join('\n');
			const blob = new Blob([csvContent], { type: 'text/csv' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'course-results.csv';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		});
	});

	// Embedded in the portal with no session of our own — see the rs-auth-required note below.
	function needsPortalLogin() {
		return window.top !== window.self && !document.body.classList.contains('logged-in');
	}

	$(function() {
		// '*' is deliberate here and on rs-auth-required below — see the note there.
		//
		// A page that needs a login hasn't finished loading as far as the portal is concerned: it is
		// about to be pointed somewhere else. Saying 'loaded' here as well would have the portal drop
		// its overlay and show this login page for the moment it takes to fetch a key, and record a
		// page view for it.
		if(!needsPortalLogin()) {
			window.parent.postMessage({
				type: 'rs-loading',
				loaded: true,
				path: window.location.pathname,
			}, '*');
		}
		$(window).on('beforeunload', function() {
			window.parent.postMessage({
				type: 'rs-loading',
				loading: true,
				path: window.location.pathname,
			}, '*');
		});
	});

	// Tells the portal — our parent frame — that this page needs a login, so it can fetch a one-time
	// key and point us at it.
	//
	// The portal used to mint that key up front and bake it into the iframe's src, which left a
	// single-use credential sitting in the src for the life of the page: anything that re-requested
	// it (a tab restore, a device waking, back/forward, a refresh in the frame) replayed a spent key.
	// Asking for one only when we actually need it means the key is used within moments of being
	// issued, and nothing stale is left behind to replay.
	//
	// Posted to '*' deliberately. It carries no credential — only that this page needs a login, and
	// the page the user was already headed for, which whoever embedded us chose in the first place.
	// The portal's preview deploys have no fixed origin to target, either. No credential or personal
	// data may be added to these messages without pinning the target origin first. The portal is the
	// side that validates, and it checks both the origin and that the message came from the frame it
	// created.
	$(function() {
		if(!needsPortalLogin()) {
			return;
		}

		// Our own path is no use as a return target on the login page — where the user was actually
		// headed is in redirect_to. Taking only the pathname drops any off-site host along with it.
		// WPS Hide Login serves that page at /login/, but it is still wp-login.php and still carries the
		// 'login' body class, so match on the class rather than the path.
		let path = window.location.pathname;
		if(document.body.classList.contains('login')) {
			const redirectTo = getParam('redirect_to');
			path = redirectTo ? new URL(redirectTo, window.location.origin).pathname : '';
		}

		window.parent.postMessage({
			type: 'rs-auth-required',
			path: path,
		}, '*');
	});

	$(function() {
		let loading = false;
		$(document).on('click', '.rs-complete-module-for-staff', function(e) {
			e.preventDefault();

			if(loading) {
				return;
			}

			const $adminSchoolIdField = $('#rs-school-id-input');
			const adminSchoolId = $adminSchoolIdField.length ? $adminSchoolIdField.val().trim() : '';
			if($adminSchoolIdField.length && adminSchoolId === '') {
				alert('You\'re an admin, so please enter the WP School ID to complete the module for.');
				$adminSchoolIdField.focus();
				return;
			}

			const courseId = $(this).data('course-id');
			const moduleId = $(this).data('module-id');
			const lessonId = $(this).data('lesson-id');

			if(!confirm('Click OK to mark this ' + (lessonId ? 'lesson' : 'module') + ' complete for you and all your staff members.')) {
				return;
			}

			const $button = $(this);
			$button.addClass('loading');
			loading = true;

			$.ajax({
				url: window.realschools.ajaxUrl,
				method: 'POST',
				data: {
					action: 'rs_complete_module_for_staff',
					moduleId,
					courseId,
					lessonId,
					adminSchoolId: adminSchoolId,
					nonce: window.realschools.nonce,
				},
			}).done(function(response) {
				if(response.success) {
					alert('Module marked complete for you and your staff members.');
					location.reload();
				} else {
					alert('Error: ' + response.data.message);
					$button.removeClass('loading');
				}
				loading = false;
			}).fail(function() {
				alert('An unexpected error occurred. Please try again later.');
				$button.removeClass('loading');
				loading = false;
			});
		});
	});

	$(function() {
		const $container = $('#course-overview-root');
		if($container.length <= 0) {
			return;
		}

		// An empty efHsId means "all EFs" (unfiltered) — only a course is required.
		const efHsId = $container.attr('data-ef-hs-id') || '';

		// data-course-id is "0" when no course is selected yet (falsy as a number,
		// but truthy as a string) — don't fire the request until a real course is chosen.
		const courseId = $container.attr('data-course-id');
		if(!courseId || courseId === '0') {
			return;
		}

		const tier = $container.attr('data-tier') || '';

		// Tier color mapping
		const tierColors = {
			'Platinum': 'rgb(229, 228, 226)', // light silver/white
			'Gold': 'rgb(255, 215, 0)',
			'Silver': 'rgb(192, 192, 192)',
			'Bronze': 'rgb(205, 127, 50)',
		};

		let chart = null;
		let chartMode = 'per-school'; // or 'grouped-by-tier'
		let chartData = null;

		function renderChart(reports, schoolTiers, schoolNames, mode) {
			const datasets = [];
			const allDates = new Set();

			if (mode === 'per-school') {
				for(const schoolId in reports) {
					const schoolData = reports[schoolId];
					const tier = schoolTiers[schoolId] || '';
					const name = schoolNames[schoolId] || schoolId;
					const color = tierColors[tier] || 'rgb(54, 162, 235)';

					const data = [];
					for(const entry of schoolData) {
						const date = entry.createdAt.split(' ')[0];
						allDates.add(date);
						data.push({
							x: date,
							y: parseFloat(entry.averageCompletion),
						});
					}

					data.sort((a, b) => a.x.localeCompare(b.x));

					datasets.push({
						label: name + (tier ? ' (' + tier + ')' : ''),
						data: data,
						borderColor: color,
						backgroundColor: color.replace('rgb', 'rgba').replace(')', ', 0.1)'),
						tension: 0.3,
						fill: false,
					});
				}
			} else {
				// Group all schools by tier, then for each date, average the completion %
				const tierData = {};
				const tierSchoolCount = {};
				for(const schoolId in reports) {
					const schoolData = reports[schoolId];
					const tier = schoolTiers[schoolId] || '';
					if (!tier) continue;
					if (!tierData[tier]) tierData[tier] = {};
					if (!tierSchoolCount[tier]) tierSchoolCount[tier] = {};
					for(const entry of schoolData) {
						const date = entry.createdAt.split(' ')[0];
						allDates.add(date);
						if (!tierData[tier][date]) {
							tierData[tier][date] = 0;
							tierSchoolCount[tier][date] = 0;
						}
						tierData[tier][date] += parseFloat(entry.averageCompletion);
						tierSchoolCount[tier][date] += 1;
					}
				}
				// For each tier, build dataset
				for(const tier in tierData) {
					const color = tierColors[tier] || 'rgb(54, 162, 235)';
					const data = [];
					for(const date in tierData[tier]) {
						const avg = tierData[tier][date] / tierSchoolCount[tier][date];
						data.push({ x: date, y: avg });
					}
					data.sort((a, b) => a.x.localeCompare(b.x));
					datasets.push({
						label: tier,
						data: data,
						borderColor: color,
						backgroundColor: color.replace('rgb', 'rgba').replace(')', ', 0.1)'),
						tension: 0.3,
						fill: false,
					});
				}
			}

			const sortedDates = Array.from(allDates).sort();

			const ctx = document.getElementById('course-overview-chart');
			if (chart) {
				chart.destroy();
			}
			chart = new window.Chart(ctx, {
				type: 'line',
				data: {
					labels: sortedDates,
					datasets: datasets,
				},
				options: {
					responsive: true,
					interaction: {
						mode: 'index',
						intersect: false,
					},
					plugins: {
						legend: {
							display: true,
							position: 'top',
							onClick: function(e, legendItem, legend) {
								const index = legendItem.datasetIndex;
								const ci = legend.chart;
								const meta = ci.getDatasetMeta(index);
								meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
								ci.update();
							},
						},
						title: {
							display: true,
							text: mode === 'per-school' ? 'Course Completion Progress by School' : 'Course Completion Progress by Tier',
						},
						tooltip: {
							callbacks: {
								label: function(context) {
									if (mode === 'grouped-by-tier') {
										return context.dataset.label + ' (avg): ' + context.parsed.y.toFixed(1) + '%';
									}
									return context.dataset.label + ': ' + context.parsed.y + '%';
								},
							},
						},
					},
					scales: {
						x: {
							display: true,
							title: {
								display: true,
								text: 'Date',
							},
						},
						y: {
							display: true,
							title: {
								display: true,
								text: 'Completion %',
							},
							min: 0,
							max: 100,
							ticks: {
								callback: function(value) {
									return value + '%';
								},
							},
						},
					},
				},
			});
		}

		$.ajax({
			url: window.realschools.ajaxUrl,
			method: 'POST',
			data: {
				action: 'rs_get_course_overview',
				efHsId,
				courseId,
				tier,
				nonce: window.realschools.nonce,
			},
		}).done(function(response) {
			if(response.success) {
				const reports = response.data.reports;
				const schoolTiers = response.data.schoolTiers || {};
				if(!reports) {
					$container.html('<p>No data available</p>');
					return;
				}

				const schoolNames = {};
				const schoolInfoMap = response.data.schoolInfoMap || {};
				for(const schoolId in schoolInfoMap) {
					schoolTiers[schoolId] = schoolInfoMap[schoolId].tier || '';
					schoolNames[schoolId] = schoolInfoMap[schoolId].name || '';
				}
				chartData = { reports, schoolTiers, schoolNames };
				renderChart(reports, schoolTiers, schoolNames, chartMode);

				const $toggleBtn = $('#toggle-all-datasets');
				let allVisible = true;

				$toggleBtn.off('click').on('click', function() {
					allVisible = !allVisible;
					chart.data.datasets.forEach((dataset, index) => {
						const meta = chart.getDatasetMeta(index);
						meta.hidden = !allVisible;
					});
					chart.update();
					$toggleBtn.text(allVisible ? 'Hide All Schools' : 'Show All Schools');
				});

				// Toggle group by tier
				const $groupBtn = $('#toggle-group-by-tier');
				$groupBtn.off('click').on('click', function() {
					if (chartMode === 'per-school') {
						chartMode = 'grouped-by-tier';
						$groupBtn.text('Show Per School');
					} else {
						chartMode = 'per-school';
						$groupBtn.text('Show Grouped by Tier');
					}
					renderChart(chartData.reports, chartData.schoolTiers, chartData.schoolNames, chartMode);
				});
			} else {
				alert('Error: ' + response.data.message);
			}
		}).fail(function() {
			alert('An unexpected error occurred. Please try again later.');
		});
	});
})(window, jQuery);

